import React from 'react'
import PropTypes from 'prop-types'
import { FormInputContainer } from '@res/styledComponents/index'

const Textarea = (props) => {
  const {
    height,
    value,
    disabled,
    label,
    marginBottom,
    width,
    maxLength,
    onChange,
    placeholder,
    showCharCount,
    suggestedMaxLength,
    countPlaceholder,
  } = props

  const getTextLengthChars = () => {
    let charCount = value?.length || 0
    if (countPlaceholder && placeholder && (!value || value.length === 0)) {
      charCount = placeholder.length
    }
    if (suggestedMaxLength) {
      return `${charCount} / ${suggestedMaxLength}`
    }

    return charCount
  }

  return (
    <FormInputContainer width={width} marginBottom={marginBottom}>
      <label>{label}</label>
      <textarea
        name={label}
        disabled={disabled}
        maxLength={maxLength}
        style={{ cursor: disabled ? 'not-allowed' : 'auto', height }}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {showCharCount && (
        <div
          className="absolute text-gray-500 text-sm"
          style={{
            bottom: 0,
            left: '4px',
          }}
        >
          {getTextLengthChars()}
        </div>
      )}
    </FormInputContainer>
  )
}

Textarea.propTypes = {
  label: PropTypes.string,
  maxLength: PropTypes.string,
  height: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.boolean,
  marginBottom: PropTypes.string,
  width: PropTypes.string,
  placeholder: PropTypes.string,
  showCharCount: PropTypes.boolean,
  suggestedMaxLength: PropTypes.number,
  countPlaceholder: PropTypes.boolean,
  onChange: PropTypes.func,
}

Textarea.defaultProps = {
  disabled: false,
  marginBottom: '20px',
  width: '100%',
}

export default Textarea
